/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Building_Holidays_Settings_SuccessInputs */



/**
* | output |
* | --- |
* | "Holiday settings have been updated successfully" |
*
* @param {Building_Holidays_Settings_SuccessInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const building_holidays_settings_success = /** @type {((inputs?: Building_Holidays_Settings_SuccessInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Building_Holidays_Settings_SuccessInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Holiday settings have been updated successfully")
	return /** @type {LocalizedString} */ ("Les informations concernant les Vacances ont bien été mises à jour")
});